import './App.css';
import Header from './components/Header';
import Footer from "./components/Footer"
import {BrowserRouter,Routes,Route} from "react-router-dom"
import { Container } from '@mui/material';
import Trending from './Pages/Trending/Trending';
import Movies from './Pages/Movies/Movies';
import Series from './Pages/Series/Series';
import Search from './Pages/Search/Search';


function App() {
  return (
    <BrowserRouter>
   <Header />
      <div className="app" >
        
      <Container>
          <Routes>
            <Route path="/" exact={true} element={<Trending/>}></Route>
            <Route path="/movies"  element={<Movies/>}></Route>
            <Route path="/series"  element={<Series />}></Route>
            <Route path="/search"  element={<Search/>}></Route>
          
</Routes>
      </Container>
      </div>
      <Footer />
      </BrowserRouter>
    
  );
}

export default App;
